import { useState, useEffect, useMemo } from "react";
import { usePermissions } from "../context/Permissioncontext";
import {
  userCanEditPlanningInCurrentView,
  isSessionReadOnlyView,
  resolveViewerPlayerIdFromUser,
  readUserFromStorage,
} from "../utils/planningAccess";

/**
 * Re-reads `user` from localStorage when permissions load (getProfile merges hasCoachRole / all_roles)
 * and when `smarttt-user-updated` fires.
 */
export function usePlanningAccess() {
  const { permissions } = usePermissions();
  const [sessionUser, setSessionUser] = useState(readUserFromStorage);

  useEffect(() => {
    setSessionUser(readUserFromStorage());
  }, [permissions]);

  useEffect(() => {
    const sync = () => setSessionUser(readUserFromStorage());
    window.addEventListener("smarttt-user-updated", sync);
    return () => window.removeEventListener("smarttt-user-updated", sync);
  }, []);

  const canEditPlanning = useMemo(
    () => userCanEditPlanningInCurrentView(sessionUser, permissions),
    [sessionUser, permissions]
  );

  const isSessionReadOnly = useMemo(
    () => isSessionReadOnlyView(sessionUser, permissions),
    [sessionUser, permissions]
  );

  const viewerPlayerId = useMemo(
    () => resolveViewerPlayerIdFromUser(sessionUser),
    [sessionUser]
  );

  return { sessionUser, canEditPlanning, isSessionReadOnly, viewerPlayerId };
}
